<template>
  <div class="myMessage">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="未读消息" name="first">
        <div slot="label" class="table-box">
          <span>未读消息</span>
          <el-badge is-dot  :hidden="true" v-if="unReadCount!=0">
            <span class="num">{{unReadCount}}</span>
          </el-badge>
        </div>
      </el-tab-pane>
      <el-tab-pane label="已读消息" name="second">
        <div slot="label" class="table-box">
          <span>已读消息</span>
          <el-badge is-dot  :hidden="true">
            <span class="num_read">{{readCount}}</span>
          </el-badge>
        </div>
      </el-tab-pane>
      <!-- <el-tab-pane label="已读消息" name="second"></el-tab-pane> -->
    </el-tabs>
    <ul class="messagebox" v-if="messageList.length>0">
      <li class="message" v-for="(item) in getmessageList.list" :key="item.id"
          @click="changemessage(item)">
        <p class="time">
          {{ getDate(item.createTime)==false? item.createTime: getDate(item.createTime)}}
          <!-- {{ item.createTime }} -->
        </p>
        <p class="content" v-if="item.msgType >= 1">
          {{serchString(item.content)===true?item.content: item.sendName+"&nbsp;&nbsp;"+item.content}}
          <span v-if="item.msgType == 3 || item.msgType == 4" class="detail"
                @click.stop="changedetail(item)">{{$t("myMessageV2.changedetail")}}></span> 
                <!-- 4是任务完成给项目创建者发消息 -->
        </p>
        <div class="content_regiht" v-if="item.msgType == 2">
          <div v-if="item.dealStatus == '0'">
            <span class="buttonone"
                  @click.stop="changeStatus(item,2)"><i>{{$t("myMessageV2.refuse")}}</i></span>
            <span class="buttontow"
                  @click.stop="changeStatus(item,1)"><i>{{$t("myMessageV2.agree")}}</i></span>
          </div>
          <div v-else>
            <span class="buttonthree"
                  v-if="item.dealStatus == '2'"><i>{{$t("myMessageV2.Rejected")}}</i></span>
            <span class="buttonthree"
                  v-else-if="item.dealStatus == '1'"><i>{{$t("myMessageV2.Agreed")}}</i></span>
            <span class="buttonthree"
                  v-else-if="item.dealStatus =='-1'"><i>{{$t("myMessageV2.InvitationCancelled")}}</i></span>
          </div>
        </div>
        <div class="content_regiht" v-if="item.msgType != 2">
          <div>
            <span class="buttonblue"
                  v-if="item.readStatus == '0'"><i>{{$t("myMessageV2.Unread")}}</i></span>
            <span class="buttonthree"
                  v-else-if="item.readStatus == '1'"><i>{{$t("myMessageV2.Read")}}</i></span>
          </div>
        </div>
        <div class="content_delete" v-if="item.readStatus == '1'" @click="DeleteMessage(item)">
          {{$t("memoryBankV2.delete")}}
        </div>
      </li>
    </ul>
    <div>
      <el-dialog center :show-close="false" :visible.sync="delShow" :before-close="closeShow">
        <DialogsHeader :title="$t('myMessageV2.RemovalMessage')" />
        <div class="delete-txt">{{$t("myMessageV2.AfterDeletingAMessageitCannotBeRecovered")}}！
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeShow">{{$t("personCenterV2.cancle")}}</el-button>
          <el-button v-preventReClick type="primary" @click="confirmDel">
            {{$t("personCenterV2.confirm")}}</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="pagination" v-if="messageList.length>0">
      <el-pagination background @current-change="handleCurrentChange"
                     @size-change="handleSizeChange" :current-page.sync="pageInfo.currentPage"
                     :page-sizes="[10, 20, 30, 40]" layout="prev, pager, next, sizes"
                     :page-size.sync="pageInfo.rows" :total="pageInfo.total" />
    </div>
    <p v-else :style="{lineHeight: '60px',color: '#909399'}">{{$t("myMessageV2.NoMessage")}}</p>
  </div>
</template>

<script>
import { updateMessageStatus, getTaskDetail, getMessage, deleteUserMessage ,getMessageReadCount} from "@/services/myMessage";

import DialogsHeader from '@/common/dialogsHeader';

import { mapState } from "vuex";

export default {
  name: "myMessage",
  beforeRouteEnter(to, from, next) { //切换路由清空sessionStorage
    if (from.path != "/") {
      sessionStorage.removeItem("Messagepage");
    }
    next();
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.layout.userInfo,
    }),
    getmessageList: function () {
      return this.$store.getters["editor/getmessageList"];
    },
  },
  data() {
    return {
      messageList: [],//消息列表

      params: {
        filter: {
          readStatus:0, 
        },
        page: 1,
        rows: 10,
      },
      pageInfo: {
        pageSize: 0,
        currentPage: 10,
        total: 0,
        rows: 10,
      },
      delShow: false,
      itemID: null,
      activeName: "first", //被激活页签
      unReadCount:0,//未读条数
      readCount:0,//已读条数
    };
  },
  components: {
    DialogsHeader
  },
  mounted() {
    this.getMessageCount()
    this.getmyMessageList();
    this.getDate();
    // this.params.page = Number(sessionStorage.getItem("Messagepage")) || 1;
    this.bus.$on('updateMessageList', () => {
      this.getmyMessageList();
    });
  },
  methods: {
    handleClick(tab) {
      this.params.page = 1;
      this.activeName = tab._props.name;
      // return
      this.getmyMessageList();
      // sessionStorage.setItem("getnumber", this.activeName); 
    },
    //取消
    closeShow() {
      this.delShow = false;
    },
    //删除消息
    DeleteMessage(item) {
      this.delShow = true;
      this.itemID = item.id;
    },
    //确定删除
    confirmDel() {
      deleteUserMessage({ id: this.itemID }).then((res) => {
        if (res.success) {
          if (this.getmessageList.list.length === 1) {
            this.params.page--;
            sessionStorage.setItem("Messagepage", this.params.page);
          }
          this.getmyMessageList();
          this.getMessageCount()
          this.$message.closeAll();
          this.$message.success(this.$t("myMessageV2.Messagedeletesuccessfully"));
          this.delShow = false;
        }
      })
    },
    //检索字符
    serchString(item) {
      let reg = RegExp(/退出/);
      let str = reg.test(item)
      return str;
    },
    //已读未读
    changemessage(item) {
      if (item.readStatus == '1') { return; }
      getMessage({ id: item.id }).then((res) => {
        if (res.success && res.resultCode == "1") {
          this.getmyMessageList();
          this.getMessageCount()
          this.$store.dispatch("layout/showhidden");
        }
      });
    },
    //获取已读未读消息数量
    async getMessageCount(){
    const {success,result} =  await getMessageReadCount()
    if(success){
      this.unReadCount = result.unReadCount
      this.readCount = result.readCount
    }
    },
    //获取当前时间对获取消息时间对比格式化
    getDate(time) {
      let date =
        typeof time === "number"
          ? new Date(time)
          : new Date((time || "").replace(/-/g, "/"));
      let diff = (new Date().getTime() - date.getTime()) / 1000;
      let dayDiff = Math.floor(diff / 86400);
      const formatDate = function (date) {
        let today = new Date(date);
        let year = today.getFullYear();
        let month = ("0" + (today.getMonth() + 1)).slice(-2);
        let day = ("0" + today.getDate()).slice(-2);
        let hour = today.getHours();
        let minute = ("0"+today.getMinutes()).slice(-2);
        let second = ("0"+today.getSeconds()).slice(-2);
        return `${year}-${month}-${day} ${hour}:${minute}`;
      };
      if (isNaN(dayDiff) || dayDiff < 0 || dayDiff >= 31) {
        return formatDate(date);
      }
      return (//超过五小时返回false 显示时间格式
        dayDiff === 0 &&
        ((diff < 60 && this.$t("myMessageV2.just")) ||
          (diff < 120 && "1" + this.$t("myMessageV2.minuteago")) ||
          (diff < 3600 && Math.floor(diff / 60) + this.$t("myMessageV2.minuteago")) ||
          (diff < 7200 && "1" + this.$t("myMessageV2.Hoursago")) ||
          (diff < 18000 && Math.floor(diff / 3600) + this.$t("myMessageV2.Hoursago")))
      );
    },
    //获取消息列表
    async getmyMessageList() {
      const self = this;
      let params = self.params
      if(this.activeName == 'first'){
        params.filter.readStatus = 0
      }else if(this.activeName == 'second'){
        params.filter.readStatus = 1
      }
      console.log(this.params,"@@@@");
      self.$store.dispatch("editor/getmyMessage", self.params).then((resp) => {
        if (resp.success) {
          // const results = resp;
          if(resp.page > resp.totalPage){
            console.log('@##');
            this.params.page = resp.totalPage
            this.getmyMessageList()
          }
          this.messageList = resp.list;
          Reflect.set(self.pageInfo, "pageSize", resp.rows);
          Reflect.set(self.pageInfo, "currentPage", resp.page);
          Reflect.set(self.pageInfo, "total", resp.totalRows);
          // if(this.activeName == 'first'){
          //   this.unReadCount = resp.totalRows
          // }else if(this.activeName == 'second'){
          //   this.readCount = resp.totalRows
          // }
        }
      });
    },

    //进入详情
    async changedetail(row) {
      const self = this;
      if (parseInt(row.sourceType) === 0) {
        let arr = [];
        this.userInfo.companyList.forEach(item => {
          arr.push(item.code)
        });
        if (!arr.includes(row.companyCode)) {
          this.$message.closeAll();
          this.$message.warning(this.$t("myMessageV2.Youhavelefttheteam"));
          return;
        }
      }
      if (row.sourceType !== null) {
        this.changemessage(row);

        let { result, success } = await getTaskDetail({
          id: row.sourceId,
        });

        if (success) {
          let obj = {};
          // 4是任务完成给项目创建者发消息 类似项目详情文件进入
          if (row.msgType == 4) {
            obj = {
              sourceLang: result.sourceLang,
              targetLang: result.targetLang,
              taskName: result.fileName,
              wordNum: result.sourceWordNum,
              userId: this.userInfo.id,
              fileSuffix: result.fileUsableSuffix,
              transModel: result.transModel,
              fileId: result.fileId,
              projectId: result.projectId,
              isSplit: true, // 接口没有，待确定
            };
            sessionStorage.setItem("fileName", result.fileName)
            if (parseInt(result.sourceType) === 0) {
              obj = {
                ...obj,
                project: result.finish,
                transStatus: 2,
                type: 'project',
                taskType: 1,
                taskId: null,
                langDesc: result.langDesc,
                progress: result.progress,
                taskCount: result.taskCount,
                finish: result.finish,
              }
            } else if (parseInt(result.sourceType) === 1 || parseInt(result.sourceType) === 2) {
              obj.project = 3;
              obj.transStatus = 1;
              obj.type = 'school';
              obj.taskType = result.taskType;
              obj.taskId = result.id;
              if (parseInt(result.sourceType) === 1) {
                obj['type-school'] = 'teacher-homework';
              } else {
                obj['type-school'] = 'teacher-test';
              }
              obj.companyCode = result.companyCode;
            }
          } else {
            obj = Object();
            Reflect.set(obj, "fromType", "message");
            Reflect.set(obj, "taskId", result.id);
            Reflect.set(obj, "fileId", result.fileId);
            Reflect.set(obj, "taskType", result.taskType);
            Reflect.set(obj, "projectId", result.projectId);
            Reflect.set(obj, "companyCode", result.companyCode);
            Reflect.set(obj, 'targetLang', (result.targetLang));
            Reflect.set(obj, 'taskName', (result.taskName));
            Reflect.set(obj, 'wordNum', (result.sourceWordNum));
            Reflect.set(obj, 'project', 3);
            Reflect.set(obj, 'userId', this.userInfo.id);
            Reflect.set(obj, 'transStatus', 1);
            Reflect.set(obj, 'fileSuffix', result.fileUsableSuffix);
            Reflect.set(obj, 'transModel', result.transModel);
            sessionStorage.setItem("fileName", result.taskName);
            if (parseInt(result.sourceType) === 0) {
              Reflect.set(obj, "type", "task");
            } else if (parseInt(result.sourceType) === 1) {
              Reflect.set(obj, "type", "school");
              Reflect.set(obj, "type-school", "student-homework");
            } else if (parseInt(result.sourceType) === 2) {
              Reflect.set(obj, "type", "school");
              Reflect.set(obj, "type-school", "student-test");
              if (result.startTime == null || new Date() < new Date(result.startTime)) {
                this.$message.closeAll();
                this.$message.warning(this.$t("myMessageV2.Testtimenotstarted"));
                return;
              }
            }
          }
          if(row.content == '提交了作业，'){
            Reflect.set(obj,'toGrade',1)
          }
          let routeData = this.$router.resolve({
            path: '/neweditor',
            query: {
              key: this.$Base64.encode(JSON.stringify(obj))
            }
          });
          window.open(routeData.href, "_self");
        }
      } else {
        self.$message.closeAll();
        self.$message.warning(this.$t("myMessageV2.Thetaskhasbeendeleted"));
      }
    },
    //同意/拒绝请求
    changeStatus(row, type) {
      const self = this;
      self.getmessageList.list.every(async item => {
        if (parseInt(row.id) === parseInt(item.id)) {
          parseInt(type) === 2 ? item.dealStatus = 2 : item.dealStatus = 1
          const params = {
            status: item.dealStatus,
            sourceId: item.companyCode,
            id: item.id
          };
          const res = await updateMessageStatus(params);
          if (res.resultCode == "1" && res.success) {
            if (parseInt(type) === 2) {
              this.$message.warning(this.$t("myMessageV2.Rejectinvitation"));
            } else {
              this.$message.success(this.$t("myMessageV2.Agreetotheinvitation"));
              // 更新团队选择下拉框
              self.$store.dispatch("layout/userInfo");
            }
            this.getmyMessageList();
          }
          return false;
        } else {
          return true;
        }
      });
    },
    //分页
    handleCurrentChange(newPage) {
      const self = this;
      sessionStorage.setItem("Messagepage", newPage)
      Reflect.set(self.params, "page", newPage);
      self.getmyMessageList(self.params);
    },
    // 分页每页显示数量改变时触发
    handleSizeChange(val) {
      // console.log(val)
      this.params.rows = val;
      this.getmyMessageList(self.params);
    }
  }
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>
